import { Navigate, useParams } from "react-router";

/** `/deep-research/shared/:token`: v1 Deep Research links (MHS-790) keep their token on the chat the report became. */
export function DeepResearchSharedLinkRedirect() {
  const { token = "" } = useParams();
  return <Navigate to={`/chat/shared/${encodeURIComponent(token)}`} replace />;
}
